<script setup>
import { computed } from 'vue'

import { useAccountingStore } from '@/stores/accounting.store'
import { useReportColumnTemplates } from '@/composables/report-column-template'

const props = defineProps({
  template: {
    type: Object,
    required: true,
  },
})

const MAX_SECTIONS = 3
const MAX_COLUMNS = 9

const { reportColumnGroupEnum } = useAccountingStore()
const { enabledSections, selectedColumns } = useReportColumnTemplates()

const sections = computed(() => enabledSections(props.template.config).slice(0, MAX_SECTIONS).map(section => ({
  key: section.key,
  columns: selectedColumns(section, props.template.config).slice(0, MAX_COLUMNS),
})))
</script>
<template>
  <div class="report-template-thumbnail column no-wrap">
    <div class="report-template-thumbnail__title" />
    <div v-if="template.is_confidential" class="report-template-thumbnail__band" />
    <template v-for="section in sections" :key="section.key">
      <div class="report-template-thumbnail__section" />
      <div class="row no-wrap report-template-thumbnail__columns">
        <i
          v-for="column in section.columns"
          :key="column.key"
          :class="{ internal: column.group === reportColumnGroupEnum.INTERNAL }"
        />
      </div>
    </template>
  </div>
</template>
<style scoped lang="scss">
.report-template-thumbnail {
  width: 3.5rem;
  aspect-ratio: 1 / 1.414;
  gap: .125rem;
  padding: .3125rem .25rem;
  overflow: hidden;
  border-radius: .125rem;
  background-color: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .08);
}

.report-template-thumbnail__title {
  width: 60%;
  height: .25rem;
  margin-bottom: .125rem;
  border-radius: .0625rem;
  background-color: $primary;
  opacity: .7;
}

.report-template-thumbnail__band {
  height: .1875rem;
  background-color: $warning;
}

.report-template-thumbnail__section {
  width: 40%;
  height: .125rem;
  margin-top: .125rem;
  background-color: $grey-8;
}

.report-template-thumbnail__columns {
  gap: .0625rem;

  i {
    flex: 1;
    height: .25rem;
    background-color: $grey-4;

    &.internal {
      background-color: $warning;
    }
  }
}
</style>
